import { render, staticRenderFns } from "./ListSelectedDescriptorPairs.vue?vue&type=template&id=f2d02c10&scoped=true"
import script from "./ListSelectedDescriptorPairs.vue?vue&type=script&lang=js"
export * from "./ListSelectedDescriptorPairs.vue?vue&type=script&lang=js"
import style0 from "./ListSelectedDescriptorPairs.vue?vue&type=style&index=0&id=f2d02c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d02c10",
  null
  
)

export default component.exports